import * as React from "react";
import Styles from "./Breadcrumbs.module.css";
export interface Props {
  children: any;
}

const BreadcrumbsSeparator: React.FC<Props> = props => {
  const { children } = props;

  return <span className={Styles.separator}>{children}</span>;
};

export default BreadcrumbsSeparator;
